/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerGetPermissionsQueryResponse, InvitationsControllerGetPermissionsPathParams, InvitationsControllerGetPermissions401, InvitationsControllerGetPermissions403 } from "../../models/invitationsController/InvitationsControllerGetPermissions";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { invitationsControllerGetPermissions } from "../../clients/invitationsService/invitationsControllerGetPermissions";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const invitationsControllerGetPermissionsQueryKey = (id: InvitationsControllerGetPermissionsPathParams["id"]) => [{
  url: '/api/v1/invitations/:id/permissions',
  params: {
    id: id
  }
}] as const;
export type InvitationsControllerGetPermissionsQueryKey = ReturnType<typeof invitationsControllerGetPermissionsQueryKey>;
export function invitationsControllerGetPermissionsQueryOptions(id: InvitationsControllerGetPermissionsPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = invitationsControllerGetPermissionsQueryKey(id);
  return queryOptions<InvitationsControllerGetPermissionsQueryResponse, ResponseErrorConfig<InvitationsControllerGetPermissions401 | InvitationsControllerGetPermissions403>, InvitationsControllerGetPermissionsQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return invitationsControllerGetPermissions(id, config);
    }
  });
}

/**
 * @description The invitation's targets expanded to every scope they reach, limited to the caller's reach.
 * @summary Get invitation scope permissions
 * {@link /api/v1/invitations/:id/permissions}
 */
export function useInvitationsControllerGetPermissions<TData = InvitationsControllerGetPermissionsQueryResponse, TQueryData = InvitationsControllerGetPermissionsQueryResponse, TQueryKey extends QueryKey = InvitationsControllerGetPermissionsQueryKey>(id: InvitationsControllerGetPermissionsPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<InvitationsControllerGetPermissionsQueryResponse, ResponseErrorConfig<InvitationsControllerGetPermissions401 | InvitationsControllerGetPermissions403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? invitationsControllerGetPermissionsQueryKey(id);
  const query = useQuery({
    ...invitationsControllerGetPermissionsQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<InvitationsControllerGetPermissions401 | InvitationsControllerGetPermissions403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}